<div class="map" [attr.id]="mapDivId">
    <div id="geolocation">
        <gis-geolocation [map]="map"></gis-geolocation>
    </div>
</div>